import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-shadow',
  templateUrl: './loading-shadow.component.html',
	styleUrls: ['./loading-shadow.component.scss']
})
export class LoadingShadowComponent {

	@Input()
	height: number;

	constructor() { }

	TAP_printStyles() {
		return { 'height': this.height };
	}

}
